function moderationOutcome(report) {
  if (report.status === 'pending') return 'İnceleme bekliyor.';
  if (report.status === 'dismissed') return 'Şikâyet reddedildi — mesaj korundu.';
  if (report.action === 'remove-message') return 'Şikâyet kabul edildi — mesaj kaldırıldı.';
  if (report.action === 'review') return 'İnceleme kapatıldı — mesaj kaldırılmadı.';
  return 'Eski karar: yapılan işlem türü kaydedilmemiş.';
}
module.exports = { moderationOutcome };
